import { Button, Result } from 'antd';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

const AccessDenied: FC = () => {
  const navigate = useNavigate();

  return (
    <Result
      status='403'
      title='403'
      subTitle='Ne pare rău, nu aveți permisiunea de a accesa această pagină.'
      extra={
        <Button type='primary' onClick={() => navigate('/home')}>
          Înapoi la pagina principală
        </Button>
      }
    />
  );
};

export default AccessDenied;


